import { render } from "./SentenceData.vue?vue&type=template&id=92e79858&scoped=true"
import script from "./SentenceData.vue?vue&type=script&lang=js"
export * from "./SentenceData.vue?vue&type=script&lang=js"

import "./SentenceData.vue?vue&type=style&index=0&id=92e79858&scoped=true&lang=css"

import exportComponent from "D:\\JavaProject\\multilingual_corpus\\multilingual_corpus\\multilingual_corpus_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e79858"]])

export default __exports__